
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124","height":"124"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 0.584314 0 0 0 0 0.596078 0 0 0 0 0.603922 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-138)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#252626","d":"M225.833 87.833V15.5c0-5.707-4.626-10.333-10.333-10.333h-29.76a15.496 15.496 0 00-10.953 4.546L152.88 31.62a15.5 15.5 0 00-4.547 10.953v45.26c0 5.707 4.627 10.334 10.334 10.334H215.5c5.707 0 10.333-4.627 10.333-10.334zM158.667 46.5H184.5a5.167 5.167 0 005.167-5.167V15.5H215.5v72.333h-56.833V46.5zM202.583 62h-31A2.584 2.584 0 00169 64.583v5.167a2.583 2.583 0 002.583 2.583h31a2.583 2.583 0 002.584-2.583v-5.167A2.584 2.584 0 00202.583 62zm33.584-36.167v72.334c0 5.707-4.627 10.333-10.334 10.333H169c0 5.707 4.626 10.333 10.333 10.333h46.5c11.414 0 20.667-9.252 20.667-20.666v-62c0-5.707-4.626-10.334-10.333-10.334z"}})])])
          )
        }
      }
    